import { useState } from "react";
import Feedback from "./index";
import { ReactComponent as Banner } from "./banner.svg";

import styles from "./index.module.scss";

const FeedBackBar = () => {
  const [showUserFeedback, setShowUserFeedback] = useState<boolean>(false);
  return (
    <div className={styles.barContainer}>
      <Banner
        data-ti="feedback_click"
        data-tn="意见反馈点击"
        className={styles.bar}
        onClick={() => setShowUserFeedback(pre => !pre)}
      />
      <Feedback
        open={showUserFeedback}
        onCancel={() => setShowUserFeedback(false)}
      />
    </div>
  );
};

export default FeedBackBar;
